const urlConstants = {
  HOME: '/',
  HOME_EN: '/en',
  JONGEREN: '/jongeren',
  JONGVOLWASSENEN_SITE: 'https://jongvolwassenen.insideoutnederland.nl',
  OPVOEDERS_SITE: 'https://jongvolwassenen.insideoutnederland.nl/opvoeders',
  OUDER_DAN_30: 'https://jongvolwassenen.insideoutnederland.nl/#ouder-dan-30',
  JONGVOLWASSENEN_SITE_EN: 'https://jongvolwassenen.insideoutnederland.nl/english',
  OPVOEDERS_SITE_EN: 'https://jongvolwassenen.insideoutnederland.nl/parents',
  OUDER_DAN_30_EN: 'https://jongvolwassenen.insideoutnederland.nl/english#ouder-dan-30',
  WATWEDOEN: '/wat-we-doen',
  WIEWEZIJN: '/wie-we-zijn',
  VRAGEN: '/vragen',
  YOUNGLEADERS: '/youngleaders',
  VOORLICHTING: '/inschrijven-voorlichting',
  TRAINING: '/inschrijven-training',
  RESULTATEN: '/resultaten',
  OPVOEDERS: '/voor-opvoeders',
  SCHOLEN: '/voor-scholen',
  VOLWASSENEN: '/voor-volwassenen',
  GEDRAGSCODE: '/gedragscode',
  CONTACT: '/contact',
  DATA: '/data',
  PRIVACY: '/privacy',
  VOORWAARDEN: '/algemene-voorwaarden',
};

export default urlConstants;
